import { toIntent } from '../intent';
import { createSubviewIntents } from './createSubviewIntents';
import { createVariants } from './createVariants';
import { setDefaults } from './setDefaults';
import { normalizeIntents, normalizeStyleIntents } from './normalizeIntents';
export function createViewOptionsIntents(config, viewOptions, isSubview = false, intents = []) {
    if (viewOptions.uses) {
        normalizeIntents(viewOptions.uses, intents);
    }
    if (viewOptions.css) {
        normalizeStyleIntents(viewOptions.css, intents);
    }
    if (!isSubview) {
        if (viewOptions.defaults) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            intents.push(setDefaults(viewOptions.defaults));
        }
        if (viewOptions.subviews) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            const subviewIntents = createSubviews(config, viewOptions.subviews);
            if (subviewIntents) {
                intents.push(subviewIntents);
            }
        }
        if (viewOptions.variants) {
            intents.push(createVariants(viewOptions.variants, viewOptions.forward, (variantOption)=>createViewOptionsIntents(config, variantOption)));
        }
    }
    return intents;
}
export function createSubviews(config, subviews) {
    let subviewIntents;
    Object.keys(subviews).forEach((subview)=>{
        if (subview in subviews) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const subviewValue = subviews[subview];
            subviewIntents !== null && subviewIntents !== void 0 ? subviewIntents : subviewIntents = createSubviewIntents({});
            subviewIntents[subview] = toIntent(normalizeIntents(subviewValue) || createViewOptionsIntents(config, subviewValue, true));
        }
    });
    return subviewIntents;
}

//# sourceMappingURL=createViewOptionsIntents.js.map